import { HStack, Pressable, Text, VStack, useMediaQuery } from "native-base";
import { COLORS } from "../../utils/colors";
import { COMMONFONTSIZE, COMMONFONTWEIGHT } from "../../utils/fonts";
import { MOBILE_VIEW_WIDTH } from "../../utils/screens";
import { Svg } from "react-native-svg";
import { locationSVG } from "../../utils/svg";

const CommonDetailCard = ({
  heading = "",
  text = "",
  headingSize = COMMONFONTSIZE.MEDIUM_FONT_SIZE,
  textSize = COMMONFONTSIZE.LARGE_MEDIUM_FONT_SIZE,
}) => {
  const [MobileWindow] = useMediaQuery({
    maxWidth: MOBILE_VIEW_WIDTH,
  });

  return (
    <VStack>
      <Text
        fontWeight={COMMONFONTWEIGHT.MEDIUM_FONT_WEIGHT}
        fontSize={headingSize}
        color={COLORS.ATTACHMENTS_TEXT_COLOR}
        pb={MobileWindow ? 1 : 2}
      >
        {heading}
      </Text>
      {heading === "Event Location" || heading === "MICE Location" ? (
        text !== "-" &&
        (/^https?:\/\/(www\.)?google\.(com|co\.in)\/maps\/place\//.test(text) ||
          /^https?:\/\/maps\.app\.goo\.gl\/[A-Za-z0-9]+$/.test(text) ||
          /^https?:\/\/(www\.)?google\.(com|co\.in)\/maps\/(place|search)\/[^\/]+\/@[\d\.,]+,([\d\.]+|-[\d\.]+),[\d\.]+z\/data=.*$|^https?:\/\/maps\.app\.goo\.gl\/[A-Za-z0-9]+$/.test(
            text
          ) ||
          /^https:\/\//.test(text)) ? (
          // <HStack>
          <Pressable>
            <a href={text} target="blank" style={{ textDecoration: "none" }}>
              <HStack>
                <Svg width="24" height="24" viewBox="0 0 -10 10">
                  {MobileWindow ? locationSVG(20, 20) : locationSVG(24, 24)}
                </Svg>
                <Text
                  fontWeight={COMMONFONTWEIGHT.MEDIUM_FONT_WEIGHT}
                  fontSize={textSize}
                  color={COLORS.THEME_COLOR}
                  pl={!MobileWindow && 1}
                  mt={!MobileWindow && "2px"}
                >
                  View Location
                </Text>
              </HStack>
            </a>
          </Pressable>
        ) : (
          // </HStack>
          <HStack>
            {/* <Svg width="24" height="24" viewBox="0 0 -10 10">
              {MobileWindow ? locationSVG(20, 20) : locationSVG(24, 24)}
            </Svg> */}
            <Text
              fontWeight={COMMONFONTWEIGHT.MEDIUM_FONT_WEIGHT}
              fontSize={textSize}
              pl={!MobileWindow && 1}
              mt={!MobileWindow && "2px"}
            >
              {text}
            </Text>
          </HStack>
        )
      ) : (
        <Text
          fontWeight={COMMONFONTWEIGHT.MEDIUM_FONT_WEIGHT}
          fontSize={textSize}
          color={COLORS.DETAIL_CARD_TEXT_COLOR}
        >
          {text}
        </Text>
      )}
    </VStack>
  );
};

export default CommonDetailCard;
